import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  table: {
    tableLayout: 'fixed',
  },
  cell: {
    padding: 8,
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    border: 0,
    textAlign: 'center',
  },
  loader: {
    fontSize: '1.3rem',
  },
  mt10: {
    marginTop: 10,
  },
}));
